import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {
  StyledInvoiceRadioSelector,
  StyledInvoiceRadioSelectorIcon,
  StyledInvoiceRadioSelectorRadio,
} from './StyledInvoiceRadioSelector';
import {Space, Tooltip} from 'antd';
import ImagePreviewTooltip from '../ImagePreviewTooltip';
import useInvoiceAttachmentPreview from '../../../../hooks/useInvoiceAttachmentPreview';
import {DownloadIcon, EyeIcon} from '../../../../icons';
import {firebaseEvents} from '../../../../snippets/firebase';
import {invoicesActions} from '../../../../state/actions/invoice.actions';
import invoicePlaceholderImg from '../../../../static/images/pages/transactions/invoice-placeholder.png';
import {amountHelpers, dateHelpers, fileHelpers, systemHelpers} from '../../../../utils/helpers';


const InvoiceRadioSelector = ({
  dispatch,
  downloadInvoice,

  invoices = [],
  onChange,
  selected,
  ...rest
}) => {
  const [selectedValue, setSelectedValue] = useState(undefined);
  const [t] = useTranslation('main');

  const {
    showPreview,
    tooltipContent
  } = useInvoiceAttachmentPreview();

  useEffect(() => {
    if (selectedValue !== selected) setSelectedValue(selected);
  }, [selected]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleRadioChange = (e) => {
    const {value} = e.target;
    setSelectedValue(value);
    onChange && onChange(e, value);
  }

  const handleOnPreviewClick = (e, id) => {
    e.preventDefault();

    if (!id) return;
    showPreview(id);
  }

  const handleOnDownloadClick = (e, id) => {
    e.preventDefault();

    if (!id) return;
    downloadInvoice(
      id,
      (data) => {
        fileHelpers.saveFile(data);
        systemHelpers.logEvent(firebaseEvents.INVOICES_DOWNLOAD_INVOICE);
      }
    );
  }

  return (
    <StyledInvoiceRadioSelector
      {...rest}
      onChange={handleRadioChange}
      value={selectedValue}
    >
      <Space
        direction='vertical'
        size='small'
      >
        {invoices.map(({ id: invoiceId, vendor, amount = 0, date: invoiceDate }, index) => {
          const date = invoiceDate ? dateHelpers.getDateWithMonth(invoiceDate, 'DD MMM YYYY') : '';

          return (
            <StyledInvoiceRadioSelectorRadio
              key={invoiceId || `radio-${index}`}
              value={invoiceId}
            >
              <Space size='small'>
                <img
                  alt='invoice placeholer'
                  className='placeholder'
                  src={invoicePlaceholderImg}
                />
                <Space direction='vertical' size={2}>
                  <Space size='middle' className='invoice-radio-details-header-title'>
                    <span className='vendor'>
                      {vendor}
                    </span>
                    <Space size={4}>
                      <ImagePreviewTooltip
                        classNames={{root: 'image-preview-tooltip-overlay transaction-details'}}
                        title={tooltipContent}
                        trigger='click'
                      >
                        <Tooltip title={t('preview')}>
                          <StyledInvoiceRadioSelectorIcon onClick={(e) => handleOnPreviewClick(e, invoiceId)}>
                            <EyeIcon />
                          </StyledInvoiceRadioSelectorIcon>
                        </Tooltip>

                      </ImagePreviewTooltip>
                      <Tooltip title={t('download')}>
                        <StyledInvoiceRadioSelectorIcon onClick={(e) => handleOnDownloadClick(e, invoiceId)}>
                          <DownloadIcon />
                        </StyledInvoiceRadioSelectorIcon>
                      </Tooltip>
                    </Space>
                  </Space>

                  <Space size='small'>
                    <span className='date'>
                      {date}
                    </span>
                    <span className='price'>
                      {amountHelpers.getAmountWithCurrencyCode(amount)}
                    </span>
                  </Space>
                </Space>
              </Space>
            </StyledInvoiceRadioSelectorRadio>
          )
        })}
      </Space>
    </StyledInvoiceRadioSelector>
  );
}

InvoiceRadioSelector.propTypes = {
  onChange: PropTypes.func,
  selected: PropTypes.any,
}

const mapDispatchToProps = {
  downloadInvoice: invoicesActions.downloadInvoice,
}

export default connect(null, mapDispatchToProps)(InvoiceRadioSelector);
